// extracted by mini-css-extract-plugin
export default {"name":"jqi9BD7b5kxLvoEvCWRi","severityExpression":"ObioRpO2OZgCn5WEtute"};